import { Component } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ActivatedRoute } from '@angular/router';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { AtributosProjeto } from 'src/app/shared/models/atributos-projeto.model';
import { Orgao } from 'src/app/shared/models/orgao.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-projeto-add',
  templateUrl: './projeto-add.component.html',
  styleUrls: ['./projeto-add.component.scss']
})
export class ProjetoAddComponent extends BaseFormComponent<ProjetoCadastro> {
  usuarioList: Usuario[];
  orgaoList: Orgao[];
  attrList: AtributosProjeto;
  permissions: ProjetoPermission = {
    edit: true,
    edit_check: true,
    edit_not_espec: true,
    edit_obj_est: true,
    edit_actived: true,
    edit_level_priority: true,
    edit_op_status: true,
    edit_pg: true,
    edit_irfe_enabled: true,
    analysis_check: true,
    analysis_spgg_check: true,
    irfe_check: true,
    ircp_check: true,
    edit_perc_status: true,
    save: true,
    delete: false
  };

  constructor(
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ){
    super(activatedRoute)
  }

  ngOnInit() {
    this.loaded();
  }

  onActivate(component) {
    component.idProjeto = null;
    component.actionLabel = 'Adicionar';
    component.permissions = this.permissions;
    component.infoProjeto = null;
  }
}
